module.exports = {"customerId":"1","organizationId":"1"}


//////////////////
// WEBPACK FOOTER
// ./src/config.json
// module id = 424
// module chunks = 0